// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adCard {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    /* justify-content: center; */
    justify-content: space-between;
    /* width: 195px; */
}

.adCardInfoCont {
    width: 100%;
}

.adCardCover {
    width: 100%;
    height: 158px;
    border-radius: 16px;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: flex-start;
    justify-content: right;
    padding: 12px;
    margin-bottom: 12px;
}

.adCardColumn {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: left;
    justify-content: left;
}

.adCardTitle {
    font-family: Alegreya Sans;
    font-size: 20px;
    font-weight: 700;
    line-height: 20px;
    text-align: left;
    color: #4B2D10;
    /* display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis; */
}

.adCardText {
    font-family: Alegreya Sans;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.2px;
    text-align: left;
    color: #4B2D10;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.adCardButton {
    background: #FF6B00;
    border-radius: 16px;
    border-radius: 16px;
    width: 100%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 11px 30px;
    font-family: Alegreya Sans;
    font-size: 16px;
    font-weight: 700;
    line-height: 12.8px;
    text-align: left;
    color: #FFE4D0;
    cursor: pointer;
}

@media (min-width: 576px) {
    .adCardCover {
        height: 175px;
    } 
}`, "",{"version":3,"sources":["webpack://./src/components/Main/AdCard/AdCard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd;;;;;8BAK0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".adCard {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n    /* justify-content: center; */\n    justify-content: space-between;\n    /* width: 195px; */\n}\n\n.adCardInfoCont {\n    width: 100%;\n}\n\n.adCardCover {\n    width: 100%;\n    height: 158px;\n    border-radius: 16px;\n    overflow: hidden;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    display: flex;\n    align-items: flex-start;\n    justify-content: right;\n    padding: 12px;\n    margin-bottom: 12px;\n}\n\n.adCardColumn {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: left;\n    justify-content: left;\n}\n\n.adCardTitle {\n    font-family: Alegreya Sans;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 20px;\n    text-align: left;\n    color: #4B2D10;\n    /* display: -webkit-box;\n    line-clamp: 2;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis; */\n}\n\n.adCardText {\n    font-family: Alegreya Sans;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 19.2px;\n    text-align: left;\n    color: #4B2D10;\n    display: -webkit-box;\n    line-clamp: 2;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.adCardButton {\n    background: #FF6B00;\n    border-radius: 16px;\n    border-radius: 16px;\n    width: 100%;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 11px 30px;\n    font-family: Alegreya Sans;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 12.8px;\n    text-align: left;\n    color: #FFE4D0;\n    cursor: pointer;\n}\n\n@media (min-width: 576px) {\n    .adCardCover {\n        height: 175px;\n    } \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
